import { mount } from 'svelte'
import DrillPage from './DrillPage.svelte'

export default (target, props) => mount(DrillPage, { target, props: {
	...props,
	content_html: (() => {
		const inner_html = target.innerHTML
		target.innerHTML = ``
		return inner_html
	})(),
} })
